import script from "./UpgradeTierReminder.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeTierReminder.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeTierReminder.vue?vue&type=style&index=0&id=f9d68498&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9d68498"]])

export default __exports__